"use strict";
/*!
 * Buttplug JS Source Code File - Visit https://buttplug.io for more info about
 * the project. Licensed under the BSD 3-Clause license. See LICENSE file in the
 * project root for full license information.
 *
 * @copyright Copyright (c) Nonpolynomial Labs LLC. All rights reserved.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VorzeA10Cyclone = void 0;
const Messages = __importStar(require("../../core/Messages"));
const Exceptions_1 = require("../../core/Exceptions");
const ButtplugDeviceProtocol_1 = require("../ButtplugDeviceProtocol");
var VorzeCommand;
(function (VorzeCommand) {
    VorzeCommand[VorzeCommand["Rotate"] = 1] = "Rotate";
    VorzeCommand[VorzeCommand["Vibrate"] = 3] = "Vibrate";
})(VorzeCommand || (VorzeCommand = {}));
class VorzeType {
    constructor() {
        this.Name = "Vorze A10 Cyclone SA";
        this.CommandType = VorzeCommand.Rotate;
        this.DeviceType = 1;
    }
}
class VorzeA10Cyclone extends ButtplugDeviceProtocol_1.ButtplugDeviceProtocol {
    constructor(aDeviceImpl) {
        super("Vorze", aDeviceImpl);
        this._devInfo = new VorzeType();
        this._clockwise = true;
        this._speed = 0;
        this.HandleRotateCmd = (aMsg) => __awaiter(this, void 0, void 0, function* () {
            if (aMsg.Rotations.length !== 1) {
                throw new Exceptions_1.ButtplugDeviceException(`Vorze A10 Cyclone devices require RotateCmd to have 1 rotation command,` +
                    ` ${aMsg.Rotations.length} sent.`, aMsg.Id);
            }
            return yield this.HandleVorzeA10CycloneCmd(new Messages.VorzeA10CycloneCmd(aMsg.Rotations[0].Speed * 100, aMsg.Rotations[0].Clockwise, aMsg.DeviceIndex, aMsg.Id));
        });
        this.HandleStopDeviceCmd = (aMsg) => __awaiter(this, void 0, void 0, function* () {
            if (this._devInfo.CommandType === VorzeCommand.Vibrate) {
                return yield this.HandleSingleMotorVibrateCmd(new Messages.SingleMotorVibrateCmd(0, aMsg.DeviceIndex, aMsg.Id));
            }
            return yield this.HandleVorzeA10CycloneCmd(new Messages.VorzeA10CycloneCmd(0, false, aMsg.DeviceIndex, aMsg.Id));
        });
        this.HandleVorzeA10CycloneCmd = (aMsg) => __awaiter(this, void 0, void 0, function* () {
            const rawSpeed = (((aMsg.Clockwise ? 1 : 0) << 7) | aMsg.Speed) & 0xff;
            yield this._device.WriteValue(Buffer.from([this._devInfo.DeviceType, this._devInfo.CommandType, rawSpeed]));
            return new Messages.Ok(aMsg.Id);
        });
        this.HandleVibrateCmd = (aMsg) => __awaiter(this, void 0, void 0, function* () {
            if (aMsg.Speeds.length !== 1) {
                throw new Exceptions_1.ButtplugDeviceException(`Vorze devices require VibrateCmd to have 1 speed commands, ` +
                    `${aMsg.Speeds.length} sent.`, aMsg.Id);
            }
            return yield this.HandleSingleMotorVibrateCmd(new Messages.SingleMotorVibrateCmd(aMsg.Speeds[0].Speed, aMsg.DeviceIndex, aMsg.Id));
        });
        this.HandleSingleMotorVibrateCmd = (aMsg) => __awaiter(this, void 0, void 0, function* () {
            const newSpeed = Math.round(aMsg.Speed * 100);
            if (newSpeed !== this._speed) {
                yield this._device.WriteValue(Buffer.from([this._devInfo.DeviceType, this._devInfo.CommandType, newSpeed]));
            }
            return new Messages.Ok(aMsg.Id);
        });
        const tmpType = VorzeA10Cyclone.DevInfos.get(aDeviceImpl.Name);
        if (tmpType !== undefined) {
            this._devInfo = tmpType;
            this._name = this._devInfo.Name;
        }
        this.MsgFuncs.set(Messages.StopDeviceCmd, this.HandleStopDeviceCmd);
        if (this._devInfo.CommandType === VorzeCommand.Rotate) {
            this.MsgFuncs.set(Messages.VorzeA10CycloneCmd, this.HandleVorzeA10CycloneCmd);
            this.MsgFuncs.set(Messages.RotateCmd, this.HandleRotateCmd);
        }
        if (this._devInfo.CommandType === VorzeCommand.Vibrate) {
            this.MsgFuncs.set(Messages.SingleMotorVibrateCmd, this.HandleSingleMotorVibrateCmd);
            this.MsgFuncs.set(Messages.VibrateCmd, this.HandleVibrateCmd);
        }
    }
    get MessageSpecifications() {
        if (this._devInfo.CommandType === VorzeCommand.Vibrate) {
            return {
                VibrateCmd: { FeatureCount: 1 },
                SingleMotorVibrateCmd: {},
                StopDeviceCmd: {},
            };
        }
        return {
            RotateCmd: { FeatureCount: 1 },
            VorzeA10CycloneCmd: {},
            StopDeviceCmd: {},
        };
    }
}
exports.VorzeA10Cyclone = VorzeA10Cyclone;
VorzeA10Cyclone.DevInfos = new Map([
    [
        "CycSA",
        Object.assign(new VorzeType(), {
            Name: "Vorze A10 Cyclone SA",
            CommandType: VorzeCommand.Rotate,
            DeviceType: 1,
        }),
    ],
    [
        "UFOSA",
        Object.assign(new VorzeType(), {
            Name: "Vorze UFO SA",
            CommandType: VorzeCommand.Rotate,
            DeviceType: 2,
        }),
    ],
    [
        "Bach smart",
        Object.assign(new VorzeType(), {
            Name: "Vorze Bach",
            CommandType: VorzeCommand.Vibrate,
            DeviceType: 6,
        }),
    ],
]);
//# sourceMappingURL=VorzeA10Cyclone.js.map